import { Logic, Operator } from 'core-components/types'

import { getJBPOfferingsCrud } from './helpers/getJBPOfferingsCrud'

export const fetchPartner360ProgramTypes = async (partnerType: string, fYear: number) => {
  const programTypesCrud = getJBPOfferingsCrud([partnerType, fYear].join(':'))

  programTypesCrud.setFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'PartnerType',
        operator: Operator.EQUAL,
        value: partnerType,
      },
      {
        field: 'FYear',
        operator: Operator.EQUAL,
        value: fYear,
      },
    ],
  })

  programTypesCrud.setSort({
    field: 'OrderBy',
    dir: 'asc',
  })

  const response = await programTypesCrud.fetch()
  if (!response.items.length) {
    programTypesCrud.removeQueries()
    throw new Error('No data provided')
  }

  return response.items
}
